import type { ReactComponentLike } from 'prop-types';

import { XGuestGuard } from '@savvy/deprecated-shared/x-components/savvy-auth/x-guest-guard';

export function withGuestGuard(Component: ReactComponentLike) {
  function WithGuestGuard(props: Record<string, unknown>) {
    return (
      <XGuestGuard>
        <Component {...props} />
      </XGuestGuard>
    );
  }

  return WithGuestGuard;
}
